/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Studio_LabelInputs */

const en_home_studio_label = /** @type {(inputs: Home_Studio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo / AI systems & automation`)
};

const lv_home_studio_label = /** @type {(inputs: Home_Studio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo / AI sistēmas un automatizācija`)
};

/**
* | output |
* | --- |
* | "Lindevo / AI systems & automation" |
*
* @param {Home_Studio_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_studio_label = /** @type {((inputs?: Home_Studio_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Studio_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_studio_label(inputs)
	return en_home_studio_label(inputs)
});